module.exports = __webpack_public_path__ + "static/media/1c44cc96.jpg";